import { Component } from '@angular/core';

@Component({
  selector: 'idp-checked-icon',
  templateUrl: './checked-icon.component.html',
  styleUrls: ['./checked-icon.component.scss']
})
export class CheckedIconComponent {}
